var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6.50939C0.75 3.21695 3.38125 0.25 7.0125 0.25C10.5625 0.25 13.25 3.16062 13.25 6.49061C13.25 10.3527 10.1 12.75 7 12.75C5.975 12.75 4.8375 12.4746 3.925 11.9363C3.60625 11.7422 3.3375 11.5983 2.99375 11.7109L1.73125 12.0865C1.4125 12.1867 1.125 11.9363 1.21875 11.5983L1.6375 10.1962C1.70625 10.0021 1.69375 9.79557 1.59375 9.63282C1.05625 8.64384 0.75 7.56097 0.75 6.50939ZM6.1875 6.50939C6.1875 6.95381 6.54375 7.31059 6.9875 7.31685C7.43125 7.31685 7.7875 6.95381 7.7875 6.51565C7.7875 6.07123 7.43125 5.71445 6.9875 5.71445C6.55 5.70819 6.1875 6.07123 6.1875 6.50939ZM9.06875 6.51565C9.06875 6.95381 9.425 7.31685 9.86875 7.31685C10.3125 7.31685 10.6687 6.95381 10.6687 6.51565C10.6687 6.07123 10.3125 5.71445 9.86875 5.71445C9.425 5.71445 9.06875 6.07123 9.06875 6.51565ZM4.10625 7.31685C3.66875 7.31685 3.30625 6.95381 3.30625 6.51565C3.30625 6.07123 3.6625 5.71445 4.10625 5.71445C4.55 5.71445 4.90625 6.07123 4.90625 6.51565C4.90625 6.95381 4.55 7.31059 4.10625 7.31685Z",
    fill: "#4D6F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.6849bc9533690d1607a5398355c818d9.svg";
export { ForwardRef as ReactComponent };